export default __webpack_public_path__ + "static/media/icon_info_category_10.339af0f8.svg";